export default {
    cantico: {
      title: 'Il Cantico delle Creature',
      subtitle: 'di San Francesco d\'Assisi',
      headerOriginal: 'Lingua originale del 1225',
      headerTranslations: 'Versione in russo',
      text: `Славься, Всевышний, премогущий, добрый Боже,
Тебе слава, честь и хвала,
и благословение всякое.
Только Тебе, Всевышний, подобается честь,
и человек недостоин назвать Твое имя.

Славься, Господи мой, со всеми Твоими творениями,
особенно с господином братом Солнцем,
который день несет нам и освещает нас своим светом.
И он прекрасен и сияет с великой славой:
Тебе, Всевышний, несет он знак.

Славься, Господи мой, за сестру Луну и звезды:
на небе Ты создал их ясными,
драгоценными и прекрасными.

Славься, Господи мой, за брата Ветра
и за воздух, и облака, и ясное небо,
и всякую погоду, по которой Ты даешь
пропитание Твоим творениям.

Славься, Господи мой, за сестру Воду,
которая весьма полезна
и смиренна, и драгоценна, и чиста.

Славься, Господи мой, за брата Огонь,
которым Ты освещаешь ночь,
и он прекрасен и радостен,
могуч и силен.

Славься, Господи мой, за нашу сестру Мать-Землю,
которая кормит нас и правит нами,
и производит разные плоды
с цветами разноцветными и травами.

Славься, Господи мой, за тех, кто прощает
ради Твоей любви и терпит
болезнь и скорбь.
Блаженны те, кто будет переносить это в мире,
ибо Ты, Всевышний, их увенчаешь.

Славься, Господи мой, за нашу сестру телесную Смерть,
от которой не может убежать живой человек.
Горе тем, кто умирает в смертном грехе!
Блаженны те, кого она найдет исполняющими
святую волю Твою,
ибо вторая смерть не причинит им вреда.

Славьте и благославляйте Господа,
и благодарите Его,
и служите Ему с великим смирением.`
    }
  }